<template>
  <card headerStyle="dark" title="Instruction" class="mb-3">
    <div class="row">
      <div class="col-12">
        <a class="float-right py-2" :href="`/import-examples/products_import.xlsx?t=${Date.now()}`">Download example file <i class="fa fa-download"></i></a>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr class="bg-info text-white">
                        <th>Column</th>
                        <th>Require</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>action</td>
                        <td>Require</td>
                        <td>Valid value in:
                            <ul>
                                <li>add: add new a record</li>
                                <li>edit: update a exist record</li>
                                <li>delete: delete a exist record</li>
                                <li>empty(blank value): ignore</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>id</td>
                        <td>Require</td>
                        <td>Require for ADD, EDIT action. Otherwise Optional</td>
                    </tr>
                    <tr>
                        <td>sku</td>
                        <td>Require</td>
                        <td>Require for ADD, UPDATE action. Otherwise Optional</td>
                    </tr>
                    <tr>
                        <td>product_type</td>
                        <td>Require</td>
                        <td>Require for ADD, UPDATE action. Otherwise Optional</td>
                    </tr>
                    <tr>
                        <td>name</td>
                        <td>Require</td>
                        <td>Require for ADD, UPDATE action. Otherwise Optional</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
  </card>
</template>

<script>

  export default {
  }
</script>
